import { CurecallModalContainer } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import UserProjectForm from './users-form.component'
import UserProjectSummary from './users-summary.component'
import { TPermission } from 'src/pages/configuration/permissions/_components/permissions.type'
import { TModalProps, TPostModalProps, TPutModalProps } from './users-table.component'

interface UsersModalProps {
  modalProps: TModalProps
  setModalProps: (modalProps: TModalProps) => void
  projectPermissionList: TPermission[]
}
export default function AddOrUpdateUserModal({
  modalProps,
  setModalProps,
  projectPermissionList,
}: UsersModalProps) {
  const { t } = useTranslation()

  return (
    <>
      <CurecallModalContainer
        title={
          modalProps?.mode === 'PUT' ? t('pages.users-page.form-title-2') : t('pages.users-page.form-title-1')
        }
        isOpen={modalProps?.mode === 'POST' || modalProps?.mode === 'PUT'}
        toggle={() => {
          setModalProps(undefined)
        }}
        closeModalAriaLabel={t('pages.users-page.cta-close')}
        dialogClassName="c-w-[900px]"
      >
        <UserProjectForm
          modalProps={modalProps as TPostModalProps | TPutModalProps}
          setModalProps={setModalProps}
          projectPermissionList={projectPermissionList}
        />
      </CurecallModalContainer>

      <CurecallModalContainer
        title={t('pages.users-page.summary-title')}
        isOpen={modalProps?.mode == 'SUMMARY'}
        toggle={() => setModalProps(undefined)}
        closeModalAriaLabel={t('pages.users-page.cta-close')}
        dialogClassName="c-w-[540px]"
      >
        <UserProjectSummary modalProps={modalProps} setModalProps={setModalProps} />
      </CurecallModalContainer>
    </>
  )
}
